<div class="version-widget">
    <button (click)="setCurrentVersion()">Set as Current</button>
    <button (click)="exitVersionPreview()">Exit Preview</button>
  </div>
  